<section *ngIf="visible">
  <div class="dialog">
    <div class="topbar">
      <h1 class="title heading-01-bold">Cambiar Clave</h1>
    </div>

    <!-- Contenido dinámico -->
    <div class="content paragraph-01-regular">
      <div id="notErrorContainer">
        <!---------- Inputs ---------->
        <div id="inputsContainer">
          <div class="inputLabelContainer">
            <label for="currentPasswordInput">Clave actual</label>
            <qr-input
              name="currentPasswordInput"
              [config]="currentPasswordConfig"
              (valueChange)="currentPasswordChange($event)"
            ></qr-input>
          </div>
          <div class="inputLabelContainer">
            <label for="newPasswordInput">Nueva clave</label>
            <qr-input
              name="newPasswordInput"
              [config]="newPasswordConfig"
              (valueChange)="newPasswordChange($event)"
            ></qr-input>
          </div>
          <div class="inputLabelContainer">
            <label for="repeatPasswordInput">Repetir clave</label>
            <qr-input
              name="repeatPasswordInput"
              [config]="repeatPasswordConfig"
              (valueChange)="repeatPasswordChange($event)"
            ></qr-input>
          </div>
        </div>
        <!---------- Conditions ---------->
        <div id="requirementsContainer">
          <div id="title" class="heading-02-bold">Condiciones a cumplir:</div>
          <div
            class="conditions"
            [ngClass]="this.errors['length'].error ? 'error' : ''"
          >
            Entre 8 y 12 caracteres
          </div>
          <div
            class="conditions"
            [ngClass]="this.errors['caps'].error ? 'error' : ''"
          >
            1 Letra mayúscula
          </div>
          <div
            class="conditions"
            [ngClass]="this.errors['number'].error ? 'error' : ''"
          >
            1 Número
          </div>
          <div
            class="conditions"
            [ngClass]="this.errors['specChar'].error ? 'error' : ''"
          >
            Sin caracteres especiales
          </div>
          <div
            class="conditions"
            [ngClass]="this.errors['userSimilar'].error ? 'error' : ''"
          >
            Distinta al usuario
          </div>
        </div>
      </div>
      <!---------- Errors ---------->
      <div id="errorContainer">
        <label class="subheading-01-semi-bold error-message" for="notSimilar">
          {{
            this.errors["notSimilar"].error
              ? this.errors["notSimilar"].message
              : ""
          }}
        </label>
      </div>
    </div>

    <!-- Botones -->
    <div class="botbar">
      <div class="botbar-actions">
        <qr-button
          [config]="buttonSubmitConfig"
          (click)="save()"
          class="button-cancel"
        ></qr-button>
      </div>
    </div>
  </div>

  <div class="shadow"></div>
</section>
